// Max decimal places for quantities
export const MAX_DECIMAL_QUANTITY_PLACES = 5
